import Vue from 'vue'
import VueRouter from 'vue-router'
import Merp from '../views/MerpSimple.vue'
import Contact from '../views/Contact.vue'
// import MerpModule from '../views/MerpModule.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import ProgMonit from '../views/ProgMonit.vue'
import ActMonit from '../views/ActMonit.vue'
import MatsMonit from '../views/MatsMonit.vue'
import MoneyMonit from '../views/MoneyMonit.vue'
import Home from '../views/Home.vue'
import NotFound from '../views/NotFound.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'CodeHit',
      metaTags: [
        {
          name: 'description',
          content: 'We are an app development start up focusing on building high-quality business apps.'
        },
        {
          name: 'og:description',
          content: 'We are an app development start up focusing on building high-quality business apps.'
        }
      ]
    }
  },
  {
    path: '/merp',
    name: 'Merp',
    component: Merp,
    meta: {
      title: 'CodeHit @mERP',
      metaTags: [
        {
          name: 'description',
          content: 'Monitor your sales, profit, expenses, inventory and employees from multiple stores in one business location.'
        },
        {
          property: 'og:description',
          content: 'Monitor your sales, profit, expenses, inventory and employees from multiple stores in one business location.'
        }
      ]
    }
  },
  {
    path: '/prog-monit',
    name: 'ProgMonit',
    component: ProgMonit,
    meta: {
      title: 'CodeHit @progMonit',
      metaTags: [
        {
          name: 'description',
          content: 'Handy work progress monitoring.'
        },
        {
          property: 'og:description',
          content: 'Handy work progress monitoring.'
        }
      ]
    }
  },
  {
    path: '/act-monit',
    name: 'ActMonit',
    component: ActMonit,
    meta: {
      title: 'CodeHit @actMonit',
      metaTags: [
        {
          name: 'description',
          content: 'Simple project monitoring of activities.'
        },
        {
          property: 'og:description',
          content: 'Simple project monitoring of activities.'
        }
      ]
    }
  },
  {
    path: '/mats-monit',
    name: 'MatsMonit',
    component: MatsMonit,
    meta: {
      title: 'CodeHit @matsMonit',
      metaTags: [
        {
          name: 'description',
          content: 'Simple project monitoring of material usages.'
        },
        {
          property: 'og:description',
          content: 'Simple project monitoring of material usages.'
        }
      ]
    }
  },
  {
    path: '/money-monit',
    name: 'MoneyMonit',
    component: MoneyMonit,
    meta: {
      title: 'CodeHit @moneyMonit',
      metaTags: [
        {
          name: 'description',
          content: 'Easily track your current balance on all your bank accounts, wallets including cash on hand.'
        },
        {
          property: 'og:description',
          content: 'Easily track your current balance on all your bank accounts, wallets including cash on hand.'
        }
      ]
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: {
      title: 'CodeHit @mERP',
      metaTags: [
        {
          name: 'description',
          content: 'We make apps that solves specific unit of task'
        },
        {
          property: 'og:description',
          content: 'We make apps that solves specific unit of task'
        }
      ]
    }
  },
  {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: {
      title: 'CodeHit',
      metaTags: [
        {
          name: 'description',
          content: 'We make apps that solves specific unit of task'
        },
        {
          property: 'og:description',
          content: 'We make apps that solves specific unit of task'
        }
      ]
    }
  },
  { 
    path: '/:pathMatch(.*)',
    component: NotFound,
    meta: {
      title: 'CodeHit',
      metaTags: [
        {
          name: 'description',
          content: 'We make apps that solves specific unit of task'
        },
        {
          property: 'og:description',
          content: 'We make apps that solves specific unit of task'
        }
      ]
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {

  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  if(nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if(previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }

  Array.from(document.querySelectorAll('[data-dynamic]')).map(el => el.parentNode.removeChild(el));

  if(!nearestWithMeta) return next();

  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    tag.setAttribute('data-dynamic', '');

    return tag;
  })
  .forEach(tag => document.head.appendChild(tag));

  next();
});


export default router
